<template>
<div id="footer">
    <div class="top">
        <!-- <div class="li">
            <img src="../assets/img/footer-bottom.png" alt srcset />
            <router-link tag="span" to>产品中心</router-link>
            <router-link tag="span" to>新闻中心</router-link>
            <router-link tag="span" to>关于我们</router-link>
        </div>
        <div class="down">
            <div class="vcode">
                <img :src="detail.image" alt srcset />
                官方公众号
            </div>
            <div class="right">
                <p>
                    <span>
                        电话：
                        <span>{{detail.tel}}</span>
                    </span>
                    <span>邮箱：{{detail.yx}}</span>
                </p>
                <p>
                    <span>
                        传真：
                        <span>{{detail.cz}}</span>
                    </span>
                    <span>地址：{{detail.address}}</span>
                </p>
            </div>
      </div>-->
        <div class="left">
            <img src="../assets/img/logo1.png" class="logo" />
            <img :src="detail.image" alt class="code" />
            <span>官方公众号</span>
        </div>
        <div class="right">
            <div class="top">
                <router-link tag="span" :to="{path:'/product'}">产品中心</router-link>
                <router-link tag="span" :to="{path:'/news'}">新闻中心</router-link>
                <router-link tag="span" :to="{path:'/About'}">关于我们</router-link>
            </div>
            <p>
                <span>
                    电话：
                    <span>{{detail.tel}}</span>
                </span>
                <span>邮箱：{{detail.yx}}</span>
            </p>
            <p>
                <span>
                    传真：
                    <span>{{detail.cz}}</span>
                </span>
                <span>地址：{{detail.address}}</span>
            </p>
        </div>
    </div>
    <div class="bottom" @click="to">ALL RIGHTS RESERVED 2019 © TANGQIAO.COM 蜀ICP10202701号-1</div>
    <van-popup v-model="show" round position="center" closeable close-icon="close" :style="{ width: '80%' }">
        <div class="affix-wrap">
            <div class="title">产品咨询</div>
            <ul>
                <li>
                    <img src="../assets/img/qq.png" alt srcset />
                    <div>
                        <div class="name">网络联系方式</div>
                        <div class="desc">QQ : {{detail.qq}}</div>
                    </div>
                </li>
                <li>
                    <img src="../assets/img/mail.png" alt srcset />
                    <div>
                        <div class="name">邮箱联系方式</div>
                        <div class="desc">邮箱： {{detail.yx}}</div>
                    </div>
                </li>
                <li>
                    <img src="../assets/img/phone.png" alt srcset />
                    <div>
                        <div class="name">通信联系方式</div>
                        <div class="desc">热线： {{detail.tel}}</div>
                    </div>
                </li>
            </ul>
        </div>
    </van-popup>
    <div class="affix" @click="show=true">
        <img src="../assets/img/service.png" alt srcset />
    </div>
</div>
</template>

<script>
import {
    pz,
    classe
} from "../assets/js/api";
export default {
    data() {
        return {
            detail: {},
            classe: [],
            show: false,
        };
    },
    created() {
        pz().then((r) => {
            this.detail = r.data;
        });
        classe({
            limit: 7,
        }).then((r) => {
            this.classe = r.data.data;
        });
    },
    methods: {
        to() {
            window.open("https://beian.miit.gov.cn/");
        },
    },
};
</script>

<style lang="less" scoped>
#footer {
    .top {
        padding: 0.15rem 0.3rem;
        box-sizing: border-box;
        background: rgb(29, 62, 85);
        display: flex;

        .left {
            display: flex;
            flex-direction: column;
            margin-right: 0.37rem;

            .logo {
                width: 1.08rem;
                height: 0.38rem;
            }

            .code {
                width: 0.81rem;
                height: 0.81rem;
                margin: 0.12rem 0;
            }

            span {
                font-size: 0.16rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #ffffff;
            }
        }

        .right {
            width: calc(100% - 1.55rem);

            .top {
                padding: 0;
                padding-top: .2rem;
                margin-bottom: .33rem;

                span {
                    font-size: 0.16rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #b8b8b8;
                }

                span:nth-child(2) {
                    display: inline-block;
                    margin: 0 0.75rem;
                }
            }

            p {
                width: 100%;
                display: flex;
                justify-content: space-between;

                &>span {
                    width: 49%;
                    font-size: 0.16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #929292;
                    line-height: 0.45rem;
                    word-break: break-all;
                }
            }
        }

        // .li {
        //   display: flex;
        //   align-items: center;

        //   img {
        //     width: 1.08rem;
        //     height: 0.38rem;
        //     margin-right: 0.37rem;
        //   }

        //   span {
        //     display: inline-block;
        //     font-size: 0.16rem;
        //     font-family: Microsoft YaHei;
        //     font-weight: bold;
        //     color: #b8b8b8;
        //   }

        //   span:not(:last-child) {
        //     margin-right: 1rem;
        //   }
        // }

        // .down {
        //   display: flex;

        //   .vcode {
        //     font-size: 0.16rem;
        //     font-family: Microsoft YaHei;
        //     font-weight: bold;
        //     color: #ffffff;

        //     margin-right: 0.3rem;
        //     margin-top: 0.13rem;

        //     img {
        //       width: 0.81rem;
        //       height: 0.81rem;
        //       display: block;
        //       margin-bottom: 9px;
        //     }
        //   }

        //   .right {
        //     width: calc(100% - 1.45rem);

        //     p {
        //       width: 100%;
        //       display: flex;
        //       justify-content: space-between;

        //       & > span {
        //         width: 49%;
        //         font-size: 0.16rem;
        //         font-family: Microsoft YaHei;
        //         font-weight: 400;
        //         color: #929292;
        //         line-height: 0.45rem;
        //         word-break: break-all;
        //       }
        //     }
        //   }
        // }
    }

    .bottom {
        width: 100%;
        text-align: center;
        line-height: 0.5rem;
        font-size: 0.09rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: white;

        background: #042a44;
    }
}

.affix {
    position: fixed;
    right: 0;
    background: #08a4fc;
    border-radius: 10px 0px 0px 10px;
    padding: 0.1rem;
    top: 40vh;
    font-size: 0;
    width: 0.5rem;
    height: 0.5rem;
    text-align: center;
    line-height: 0.5rem;
    z-index: 2;

    img {
        width: 0.3rem;
        height: 0.3rem;
        vertical-align: middle;
    }
}

.affix:active {
    opacity: 0.78;
}

.affix-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0.5rem;

    .title {
        width: 0.4rem;
        white-space: nowrap;
        border-bottom: 1px solid #00a1e9;
        font-size: 0.32rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #4c4c4c;
        text-align: center;
        text-indent: -1.5em;
        margin-bottom: 0.5rem;
        padding-bottom: 0.1rem;
    }

    ul {
        li {
            display: flex;
            padding-left: 0.4rem;
            box-sizing: border-box;
            margin-bottom: 0.4rem;

            img {
                width: 0.5rem;
                height: 0.5rem;
                margin-right: 0.47rem;
            }

            &>div {
                width: calc(100% - 0.87rem);

                .name {
                    font-size: 0.22rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #343434;
                    margin-bottom: 0.16rem;
                }

                .desc {
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #666666;
                    word-break: break-all;
                }
            }
        }
    }
}
</style>
